// extracted by mini-css-extract-plugin
export default {"section":"AboutMe_section__6CZxn","container":"AboutMe_container__le9or","description":"AboutMe_description__jWmwR","highlight":"AboutMe_highlight__Dxweu"};